import { ReactNode, useState } from 'react';
import { View } from 'react-native';
import { Gesture, GestureDetector } from 'react-native-gesture-handler';
import { styles } from './styles';

type SinglePressBtn = {
  onPress: () => void;
};

type LongPressBtn = {
  onPressIn: () => void;
  onPressOut: () => void;
};

type GestureButtonProps = {
  children: ReactNode;
  isDisabled?: boolean;
} & (SinglePressBtn | LongPressBtn);

export const GestureButton = ({
  children,
  isDisabled,
  ...props
}: GestureButtonProps) => {
  const [longPressed, setLongPressed] = useState(false);
  const isSinglePress = 'onPress' in props;

  const pressGesture = Gesture.Tap()
    .runOnJS(true)
    .onBegin(() => isSinglePress && props.onPress())
    .enabled(!isDisabled);

  const longPressGesture = Gesture.LongPress()
    .runOnJS(true)
    .onBegin(() => {
      setLongPressed(true);
      !isSinglePress && props.onPressIn();
    })
    .onStart(() => !isSinglePress && props.onPressIn())
    .onEnd(() => !isSinglePress && props.onPressOut())
    .onTouchesUp(({ numberOfTouches }) => {
      if (numberOfTouches > 0) {
        return;
      }
      !isSinglePress && props.onPressOut();
      setLongPressed(false);
    })
    .onTouchesCancelled(() => {
      !isSinglePress && props.onPressOut();
      setLongPressed(false);
    })
    .maxDistance(200)
    .enabled(!isDisabled);

  const activeGesture = isSinglePress ? pressGesture : longPressGesture;

  return (
    <GestureDetector gesture={activeGesture}>
      <View
        style={
          isDisabled
            ? styles.disabled
            : longPressed
              ? styles.pressed
              : undefined
        }
      >
        {children}
      </View>
    </GestureDetector>
  );
};
